// @flow
import { CategoryTypes, fromSlug } from "Commons/Modules/category";
import { Contract as DesktopContract } from "../Desktop/components/Contract";
import { Provider as DesktopProvider } from "../Desktop/components/Provider";
import { Customer as DesktopCustomer } from "../Desktop/components/Customer";
import { Confirmation as DesktopConfirmation } from "../Desktop/components/Confirmation/Confirmation";

import { Offer as MobileOffer } from "../Mobile/components/Offer/Offer";
import { Contract as MobileContract } from "../Mobile/components/Contract";
import { Provider as MobileProvider } from "../Mobile/components/Provider";
import { Customer as MobileCustomer } from "../Mobile/components/Customer";
import { Confirmation as MobileConfirmation } from "../Mobile/components/Confirmation";
import { getSlug } from "./Steps";
import { isMobile } from "../../../../Commons/Utilities";
import { getStepRoute } from "./Routes";

export const MOBILESTEPS = {
  OFFER: "OFFER",
  CONTRACT: "CONTRACT",
  PROVIDER: "PROVIDER",
  CUSTOMER: "CUSTOMER",
  CONFIRMATION: "CONFIRMATION",
};

export const STEPS = {
  OFFER: "OFFER",
  CONTRACT: "CONTRACT",
  PROVIDER: "PROVIDER",
  CUSTOMER: "CUSTOMER",
  CONFIRMATION: "CONFIRMATION",
};

const defaultPath = [
  {
    component: DesktopContract,
    id: STEPS.CONTRACT,
    route: "anschluss",
  },
  {
    component: DesktopProvider,
    id: STEPS.PROVIDER,
    route: "anbieter",
  },
  {
    component: DesktopCustomer,
    id: STEPS.CUSTOMER,
    route: "persoenliche-daten",
  },
  {
    component: DesktopConfirmation,
    id: STEPS.CONFIRMATION,
    route: "bestaetigung",
  },
];

const PATHS: Dict = {
  [CategoryTypes.ELECTRICITY]: defaultPath,
  [CategoryTypes.GAS]: defaultPath,
};

const defaultMobilePath = [
  {
    component: MobileOffer,
    id: MOBILESTEPS.OFFER,
    route: "angebot",
  },
  {
    component: MobileContract,
    id: MOBILESTEPS.CONTRACT,
    route: "anschluss",
  },
  {
    component: MobileProvider,
    id: MOBILESTEPS.PROVIDER,
    route: "anbieter",
  },
  {
    component: MobileCustomer,
    id: MOBILESTEPS.CUSTOMER,
    route: "persoenliche-daten",
  },
  {
    component: MobileConfirmation,
    id: MOBILESTEPS.CONFIRMATION,
    route: "bestaetigung",
  },
];

const MOBILEPATHS: Dict = {
  [CategoryTypes.ELECTRICITY]: defaultMobilePath,
  [CategoryTypes.GAS]: defaultMobilePath,
};

export { PATHS, MOBILEPATHS };

export const firstStepRoute = (categorySlug: string, authenticated?: boolean | string) => {
  return getStepRoute(
    authenticated,
    categorySlug,
    getSlug(
      isMobile() ? MOBILEPATHS[`${fromSlug(categorySlug) || ""}`][1].id : PATHS[`${fromSlug(categorySlug) || ""}`][0].id
    )
  );
};
